import GalleryButton from './GalleryButton3';

export default GalleryButton;